<template>
  <div class="uk-container uk-container-expand uk-margin-top card-scrollable">
    <h1 class="uk-heading-line">
      {{ headerTitle }}
    </h1>

    <div class="uk-margin-top">
      <div
        class="uk-child-width-expand@s uk-grid-medium"
        uk-grid
      >
        <div
          v-if="!isCompanyRole"
          class="uk-width-1-1 uk-width-1-1@s uk-width-3-5@m uk-width-3-5@l"
        >
          <h4>Total Perusahaan</h4>
          <total-company
            :is-loading="isLoading"
            :company-counts="totalCompanyCounts"
          />
        </div>

        <div class="uk-width-1-1 uk-width-1-1@s uk-width-1-1@m uk-width-1-1@l">
          <h4>{{ isCompanyRole ? 'Total Karyawan' : 'Total Peserta' }}</h4>
          <total-participant
            :is-loading="isLoading"
            :is-company-role="isCompanyRole"
            :employee-counts="employeeCountsForDisplay"
          />
        </div>

        <div class="uk-width-1-1 uk-width-1-1@s uk-width-1-1@m uk-width-1-1@l">
          <h4>Total Pengkinian Data</h4>
          <total-update-data
            :is-loading="isLoading"
            :is-company-role="isCompanyRole"
            :change-counts="changeCountsForDisplay"
          />
        </div>

        <div class="uk-width-1-1 uk-width-1-1@s uk-width-1-1@m uk-width-1-1@l">
          <h4>Total Klaim</h4>
          <total-claim
            :is-loading="isLoading"
            :is-company-role="isCompanyRole"
            :claim-counts="claimCountsForDisplay"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { PREFIX_IMAGE } from '@/utils/constant'
import { getUserProfile, getUserEmployee } from '@/utils/auth'
import getHeaderTitle from '@/utils/header-title'
import TotalCompany from './Component/TotalCompany'
import TotalParticipant from './Component/TotalParticipant'
import TotalUpdateData from './Component/TotalUpdateData'
import TotalClaim from './Component/TotalClaim'

export default {
  components: {
    TotalCompany,
    TotalParticipant,
    TotalUpdateData,
    TotalClaim
  },
  data() {
    return {
      isLoading: false,
      images: PREFIX_IMAGE
    }
  },
  computed: {
    ...mapGetters({
      totalCompanyCounts: 'dashboard/get_total_company_counts',
      totalEmployeeCounts: 'dashboard/get_total_employee_counts',
      totalChangeCounts: 'dashboard/get_total_change_counts',
      totalClaimCounts: 'dashboard/get_total_claim_counts',
      companyEmployeeCounts: 'dashboard/get_company_employee_counts',
      companyChangeCounts: 'dashboard/get_company_change_counts',
      companyClaimCounts: 'dashboard/get_company_claim_counts'
    }),
    headerTitle() {
      return getHeaderTitle(this.$route.fullPath)
    },
    isCompanyRole() {
      const user = getUserProfile()
      return user?.role?.name?.toUpperCase() === 'COMPANY'
    },
    companyId() {
      const user = getUserProfile()
      const userEmployee = getUserEmployee()
      return user?.user_employee?.company?.id || userEmployee?.id || ''
    },
    employeeCountsForDisplay() {
      return this.isCompanyRole ? this.companyEmployeeCounts : this.totalEmployeeCounts
    },
    changeCountsForDisplay() {
      return this.isCompanyRole ? this.companyChangeCounts : this.totalChangeCounts
    },
    claimCountsForDisplay() {
      return this.isCompanyRole ? this.companyClaimCounts : this.totalClaimCounts
    }
  },
  async mounted() {
    this.isLoading = true
    if (this.isCompanyRole && this.companyId) {
      const params = { companyId: this.companyId }
      await Promise.all([
        this.getCompanyEmployeeCounts(params),
        this.getCompanyChangeCounts(params),
        this.getCompanyClaimCounts(params)
      ])
    } else if (!this.isCompanyRole) {
      await Promise.all([
        this.getTotalCompanyCounts(),
        this.getTotalEmployeeCounts(),
        this.getTotalChangeCounts(),
        this.getTotalClaimCounts()
      ])
    }
    this.isLoading = false
  },
  methods: {
    ...mapActions({
      getTotalCompanyCounts: 'dashboard/getTotalCompanyCounts',
      getTotalEmployeeCounts: 'dashboard/getTotalEmployeeCounts',
      getTotalChangeCounts: 'dashboard/getTotalChangeCounts',
      getTotalClaimCounts: 'dashboard/getTotalClaimCounts',
      getCompanyEmployeeCounts: 'dashboard/getCompanyEmployeeCounts',
      getCompanyChangeCounts: 'dashboard/getCompanyChangeCounts',
      getCompanyClaimCounts: 'dashboard/getCompanyClaimCounts'
    })
  }
}
</script>

<style scoped>
  h4 {
    font-family: 'Poppins';
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    color: #3C4858;
  }
</style>
